import { Key, State as LkfState } from "@linkfluence/core/state";

type State = Pick<LkfState, Key.Modal>;

export const modalIsOpen = (state: State, modalId: string) => {
  return (
    Object.prototype.hasOwnProperty.call(state[Key.Modal], modalId) &&
    state[Key.Modal][modalId] === true
  );
};
